import PeopleIcon from '@material-ui/icons/People';
import { Grid, GridSize } from '@material-ui/core';
import React from 'react';
import { countBookingPeople } from '@crm/utils';

/**
 * Composant d'affichage des personnes d'une réservation
 * 
 * Ce composant affiche :
 * - Le nombre de personnes avec icône
 * - Indication visuelle si des instructeurs sont présents
 * - Liste des instructeurs avec tooltip
 * - Layout responsive avec Grid
 * 
 * Logique métier :
 * - Calcul du nombre de personnes avec countBookingPeople
 * - Option pour compter ou non les instructeurs
 * - Icône People avec bordure si instructeurs présents
 * - Affichage des noms d'instructeurs avec ellipsis
 * 
 * @param people Données des personnes de la réservation
 * @param instructors Liste des instructeurs (optionnelle)
 * @param haveInstructor Indique si des instructeurs sont présents
 * @param countInstructors Indique si les instructeurs doivent être comptés
 * @param _xs Taille de colonne pour le layout responsive
 * @returns Composant React d'affichage des personnes
 */
export const ReservationPeopleColumn: React.FC<{
  people: CRM.BookingPeople;
  instructors?: string[];
  haveInstructor?: boolean;
  countInstructors?: boolean;
  _xs?: GridSize;
}> = ({ people, instructors, haveInstructor, countInstructors, _xs }) => (
  /*<Box display="flex" alignItems="end">
    {countBookingPeople(people, instructors)}&nbsp;
    {!haveInstructor &&
      <PeopleIcon />
    }
    {haveInstructor && haveInstructor === true &&
      (
      <Box>
        <PeopleIcon style={{ border: '1px solid currentColor' }} />
        <label>{instructors?.map((instructor) => instructor).join(', ')}</label>
      </Box>
      )
    }
  </Box>*/
  <Grid container spacing={1} xs={12}>
    <Grid container alignItems='center' xs={_xs? _xs : 6}>
      <span>
       { countBookingPeople(people, (countInstructors && countInstructors === true) ? instructors : undefined)}&nbsp;
      </span>
    {!haveInstructor &&
        <PeopleIcon />
    }
    {haveInstructor && haveInstructor === true &&
      (
        <PeopleIcon style={{ border: '1px solid currentColor' }} />
      )
    }
  </Grid>
    {haveInstructor && haveInstructor === true &&
        (
      <Grid
        title={'Monit : '+instructors?.map((instructor) => instructor).join(', ')}
        item
        xs={_xs? _xs : 6}
        style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
      >
        {instructors?.map((instructor) => instructor).join(', ')}
      </Grid>
      )
    }
  </Grid>
);
/**
 * Composant d'affichage des personnes d'arrivée d'une réservation
 * 
 * Ce composant affiche :
 * - Le nombre de personnes à l'arrivée (si spécifié) ou le nombre total
 * - Indication visuelle si des instructeurs sont présents
 * - Liste des instructeurs avec tooltip
 * - Layout responsive avec Grid
 * 
 * Logique métier :
 * - Priorité au nombre de personnes à l'arrivée si spécifié
 * - Fallback sur le calcul standard si pas de nombre d'arrivée
 * - Validation que le nombre d'arrivée est >= 0
 * - Icône People avec bordure si instructeurs présents
 * 
 * @param people Données des personnes de la réservation
 * @param peopleAtArrival Nombre de personnes à l'arrivée (optionnel)
 * @param instructors Liste des instructeurs (optionnelle)
 * @param haveInstructor Indique si des instructeurs sont présents
 * @returns Composant React d'affichage des personnes d'arrivée
 */
export const ReservationArrivalPeopleColumn: React.FC<{
  people: CRM.BookingPeople;
  peopleAtArrival?: number | null;
  instructors?: string[];
  haveInstructor?: boolean;
}> = ({ people, peopleAtArrival, instructors, haveInstructor }) => (
  <Grid container spacing={1} xs={12}>
    <Grid container alignItems='center' xs={6}>
    {(peopleAtArrival !== null
      && peopleAtArrival !== undefined
      && peopleAtArrival >= 0) ?
      peopleAtArrival : countBookingPeople(people, instructors)}&nbsp;
      {!haveInstructor &&
        <PeopleIcon />
      }
      {haveInstructor && haveInstructor === true &&
        <PeopleIcon style={{ border: '1px solid currentColor' }} />
      }
    </Grid>
    {haveInstructor && haveInstructor === true &&
        (
      <Grid
        title={'Monit : '+instructors?.map((instructor) => instructor).join(', ')}
        item
        xs={6}
        style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
      >
        {instructors?.map((instructor) => instructor).join(', ')}
      </Grid>
      )
    }
  </Grid>
);
